"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderRegions = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const addSpace = (regions, index) => {
  if (index === 0 && regions.length > 1) {
    return true;
  } else if (index !== 0 && index !== regions.length - 1) {
    return true;
  } else {
    return false;
  }
};
const renderRegions = function () {
  let regions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "luna-admin-product-data__region-list"
  }, regions.map((region, index) => {
    const space = addSpace(regions, index);
    return /*#__PURE__*/_react.default.createElement("li", {
      className: `luna-admin-product-data__region-list-item ${space ? "luna-admin-product-data__region-list-item--add-space" : "luna-admin-product-data__region-list-item--default"}`,
      key: region
    }, region);
  }));
};
exports.renderRegions = renderRegions;